(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    

var loadProductRecommendationsIntoSection = function() {

  var productRecommendationsSection =
    document.querySelector(".related-products");

  if (productRecommendationsSection === null) {
    return;
  }

  var request = new XMLHttpRequest();

  request.open(
    "GET",
    productRecommendationsSection.dataset.url
  );

  request.onload = function() {

    if (request.status >= 200 && request.status < 300) {

      var container = document.createElement("div");

      container.innerHTML = request.response;

      var newSection =
        container.querySelector(".related-products");

      if (newSection) {

        productRecommendationsSection.innerHTML =
          newSection.innerHTML;

      }

    }

  };

  request.send();

};


/* =========================================
   SHOPIFY THEME EDITOR
   ========================================= */

document.addEventListener(
  "shopify:section:load",
  function(event) {

    var section =
      document.querySelector(
        '[data-section-id="' +
        event.detail.sectionId +
        '"].related-products'
      );

    if (section) {
      loadProductRecommendationsIntoSection();
    }

  }
);


/* =========================================
   INITIAL LOAD
   ========================================= */

loadProductRecommendationsIntoSection();


  } catch(e) { console.error(e); }
})();
})();
